import React from 'react';
import { motion } from 'framer-motion';
import { Section, CHECKOUT_URL, PRICE_EUR, PRICE_EUR_VALUE, PRODUCT_NAME } from './Shared';
import { trackPixelEvent } from '../utils/metaPixel';
export const Pricing = () => <Section id="pricing" glow className="bg-brand-paper/70 rounded-sm my-12 border border-brand-gold/40" data-id="element-199" data-mp="2ohnwdweacqhv">
    <div className="text-center mb-10 pt-10" data-id="element-200" data-mp="2jknu7wkk47w1">
      <span className="inline-block border border-brand-gold/60 text-brand-goldDark font-seal text-[10px] md:text-xs uppercase tracking-seal px-4 py-1.5 rounded-sm mb-6" data-id="element-201" data-mp="2jlyw1qufz5ki">
        Prezzo di lancio
      </span>
      <h2 className="text-3xl md:text-5xl font-display font-bold text-brand-purpleDark" data-id="element-202" data-mp="25s7vv92loy1g">
        Il tuo <span className="headline-shine" data-id="element-203" data-mp="20t4qtommerth">Mega Pack Qi Gong™</span>
      </h2>
      <p className="text-brand-text/70 mt-4 text-sm md:text-base" data-id="element-204" data-mp="20v7o8tq3rn88">
        Un unico pack per organizzare il tuo lavoro di insegnamento.
      </p>
    </div>

    <div className="max-w-2xl mx-auto" data-id="element-205" data-mp="3c936ibcb0c3o">
      <div className="relative rounded-sm" data-id="element-206" data-mp="3cae7k3ed75r3">
        <span className="glow-frame" aria-hidden="true" data-id="element-207" data-mp="3vzymyh8jx933" />
        <div className="relative z-[1] w-full text-left rounded-sm p-6 md:p-8 bg-brand-paper border border-brand-purpleDark/10" data-id="element-208" data-mp="3w1jfy2f7wjyu">
          <p className="font-seal text-[10px] uppercase tracking-seal text-brand-goldDark mb-4" data-id="element-209" data-mp="9si9s1gd8n2q">
            Il sistema completo
          </p>

          <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-210" data-mp="eqtig8uxcrjd">
            <div className="min-w-0" data-id="element-211" data-mp="3daa960wu09ay">
              <h3 className="font-display font-bold text-xl md:text-2xl text-brand-purpleDark leading-tight" data-id="element-212" data-mp="3d74jajgdp3e6">
                {PRODUCT_NAME}
              </h3>
              <p className="text-sm text-brand-muted mt-1.5" data-id="element-213" data-mp="3n5k8uhzrc4lk">
                3 volumi principali + 5 bonus pratici · Oltre 300 pagine
              </p>
              <p className="text-sm text-brand-text/80 mt-3 max-w-sm" data-id="element-214" data-mp="2uipp5narl995">
                Un sistema visuale e operativo per progettare, insegnare e
                adattare lezioni di Qi Gong con più chiarezza.
              </p>
            </div>

            <div className="shrink-0 border-t border-brand-gold/30 pt-5 text-center sm:border-t-0 sm:border-l sm:pt-0 sm:pl-6 sm:text-right" data-id="element-215" data-mp="2rfa63qn76hgx">
              <p className="font-display font-bold text-4xl md:text-5xl leading-none text-brand-purpleDark" data-id="element-216" data-mp="316oaocu0a7gx">
                {PRICE_EUR}
              </p>
              <p className="text-xs text-brand-muted mt-3 max-w-[15rem] mx-auto sm:mx-0 leading-relaxed" data-id="element-217" data-mp="2w83aueio1pt0">
                Pagamento unico · Materiale digitale in PDF · Accesso immediato
                dopo l’acquisto
              </p>
            </div>
          </div>
        </div>
      </div>

      <motion.a href={CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout', {
      content_name: PRODUCT_NAME,
      value: PRICE_EUR_VALUE,
      currency: 'EUR'
    })} whileHover={{
      scale: 1.015
    }} whileTap={{
      scale: 0.985
    }} className="mt-6 w-full inline-flex items-center justify-center px-6 py-5 text-base md:text-lg font-semibold uppercase tracking-wide text-brand-surface purple-gradient-bg rounded-sm ring-1 ring-brand-goldLight/50 animate-glow-pulse relative overflow-hidden cta-shimmer" data-id="element-218" data-mp="2igy4yuopg1a8">
        <span className="relative z-10" data-id="element-219" data-mp="57dr11c0ewa4">
          Voglio il mio Mega Pack Qi Gong — {PRICE_EUR}
        </span>
      </motion.a>

      <p className="text-center text-xs md:text-sm text-brand-muted pt-5" data-id="element-220" data-mp="3rgexl3erwv6r">
        Garanzia di 7 giorni · Pagamento sicuro · Uso personale
      </p>
    </div>
  </Section>;